import { render, staticRenderFns } from "./subcategoryView.vue?vue&type=template&id=47060be6&"
import script from "./subcategoryView.vue?vue&type=script&lang=js&"
export * from "./subcategoryView.vue?vue&type=script&lang=js&"
import style0 from "./subcategoryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports